import { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// Keep the expanded icon alignment until the drawer has finished shrinking.
export default function useDrawerContent(open) {
    const [contentExpanded, setContentExpanded] = useState(open);
    const theme = useTheme();
    const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
    const collapseDuration = theme.transitions.duration.leavingScreen;

    useEffect(() => {
        if (open || reducedMotion) {
            setContentExpanded(open);
            return undefined;
        }
        // Fallback if the browser skips the width transition event.
        const timeout = setTimeout(() => setContentExpanded(false), collapseDuration + 50);
        return () => clearTimeout(timeout);
    }, [open, reducedMotion, collapseDuration]);

    const onTransitionEnd = event => {
        if (event.target === event.currentTarget && event.propertyName === 'width') {
            setContentExpanded(open);
        }
    };

    return { contentExpanded, onTransitionEnd };
}
